module.exports = __webpack_public_path__ + "img/喜报4.faf9ede3.jpg";